package com.essntl.features.itinerary.ui.all_itinerary.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.esIconPainterResource
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AllItinerariesEmpty(
    modifier: Modifier = Modifier,
) {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Image(
            painter = esIconPainterResource(EsIcons.EmptyList),
            contentDescription = null,
            modifier = Modifier
                .padding(
                    vertical = 17.dp,
                    horizontal = 25.dp,
                )
                .width(150.dp)
                .height(166.dp),
        )

        Text(
            text = "No itineraries have been added",
            color = MaterialTheme.esColorScheme.textSecondary,
            style = MaterialTheme.esTypography.p1Medium16,
            textAlign = TextAlign.Center,
        )
    }
}